import React from "react";

const UserTypeItem = () => {
  return <div>UserTypeItem</div>;
};

export default UserTypeItem;
